import { useEffect, useState } from "react";
import { Collapse } from "@mui/material";
import NotificationItem from "./NotificationItem";

export default function HomeNotifications({
  activeNotifs = [],
  viewAllCount,
  onVisibleChange,
}) {
  const [visible, setVisible] = useState([]);

  // Inicia cerrado y solo abre cuando viewAllCount cambia
  useEffect(() => {
    if (viewAllCount === 0) {
      setVisible(Array(activeNotifs.length).fill(false));
    } else {
      setVisible(Array(activeNotifs.length).fill(true));
    }
  }, [activeNotifs, viewAllCount]);

  useEffect(() => {
    if (onVisibleChange) {
      onVisibleChange(visible);
    }
  }, [visible, onVisibleChange]);

  const handleClose = (idx) => {
    setVisible((prev) => {
      const updated = [...prev];
      updated[idx] = false;
      return updated;
    });
  };

  return (
    <>
      {activeNotifs.map((notif, idx) => (
        <Collapse key={notif.id} in={visible[idx]}>
          <NotificationItem notif={notif} onClose={() => handleClose(idx)} />
        </Collapse>
      ))}
    </>
  );
}
